<p>
  product-info works!
</p>
